import { Controller } from "@hotwired/stimulus"

// Tabs: tab targets carry data-tab="name", panel targets data-tab-panel="name".
// Only this controller's own targets switch, so nested tab sets stay independent.
// With a param value the active tab is mirrored in that query parameter, so a
// Turbo morph refresh renders the same tab server-side.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = { param: String }

  showTab(event) {
    if (this.hasParamValue) event.preventDefault()
    this.select(event.currentTarget)
  }

  keydown(event) {
    const tabs = this.tabTargets
    const index = tabs.indexOf(event.currentTarget)
    const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 }[event.key]
    if (next === undefined) return

    event.preventDefault()
    const tab = tabs[(next + tabs.length) % tabs.length]
    this.select(tab)
    tab.focus()
  }

  select(selected) {
    const name = selected.dataset.tab
    this.tabTargets.forEach(tab => {
      const isActive = tab === selected
      tab.setAttribute("aria-selected", isActive)
      tab.tabIndex = isActive ? 0 : -1
      this.activeClasses.forEach(c => tab.classList.toggle(c, isActive))
      this.inactiveClasses.forEach(c => tab.classList.toggle(c, !isActive))
    })
    this.panelTargets.forEach(panel => panel.classList.toggle("hidden", panel.dataset.tabPanel !== name))
    selected.scrollIntoView({ block: "nearest", inline: "nearest" })

    if (this.hasParamValue) {
      const url = new URL(window.location.href)
      url.searchParams.set(this.paramValue, name)
      history.replaceState(history.state, "", url)
    }
  }
}
